<template>
  <div id="leaderboard">
    <div class="modal-dialog bg-light margin-10">
      <table class="ranking-rewards text-center">
        <tr>
          <th class="font-medium padding-horizontal-10">
            {{getTranslatedText('Rank')}}
          </th>
          <th class="font-medium padding-horizontal-10">
            {{getTranslatedText('Player')}}
          </th>
          <th class="font-medium padding-horizontal-10">
            {{getTranslatedText('Played')}}
          </th>
          <th class="font-medium padding-horizontal-10">
            {{getTranslatedText('Prize')}}
          </th>
        </tr>
        <!-- {{model}} -->
        <tr class="bottom-border" v-for="player in model" :style="`--bgcolor: ${bgTheme}`">
          <td>{{player.rank}}</td>
          <td>
            <div class="align-hor center-ver" style="width: 150px;">
              <div class="text-center margin-right-5" style="border-radius: 50%; background-color: #ccc; height: 32px; width: 32px;">
                <img class="semi-medium-icon" src="@/assets/user.svg">
              </div>
              <div class="player-name" v-if="player.name">{{player.name}}</div>
              <div class="player-name" v-else>{{player.mobile}}</div>
            </div>
          </td>
          <td>{{player.play_count}}</td>
          <td>{{player.total_prize}} {{getTranslatedText(player.prize_type)}}</td>
        </tr>
      </table>
      <div class="bg-light padding-10 top-border-light-grey align-hor center-hor center-ver">
        <button class="custom-button radius-5 padding-0520 text-light font-bold text-large align-hor center-hor center-ver" v-on:click="shareOnWhatsApp">
          <div class="margin-right-10">Share your rank</div>
          <img class="extra-medium-icon" src="@/assets/share.png">
        </button>
      </div>
    </div>
  </div>
</template>
<script>
  import { globals } from '@/mixins/globals'
  export default {
    mixins: [globals],
    props: {
      model: Array
    },
    data() {
      return {
        output: ""
      }
    },
    methods: {
      shareOnWhatsApp() {
        var playstore_url = "https://play.google.com/store/apps/details?id=com.dealshare&hl=en_IN";
        var whatsapp_url = "whatsapp://send?text="+this.shareMessage;
        window.location.href = whatsapp_url + "%0D%0A" +playstore_url;
      }
    }
  }
</script>
<style>
  .close-lboard {
    top: 15px;
    right: 15px;
    border-radius: 50%;
    width: 32px;
    height: 32px;
    z-index: 3;
  }
  .player-name {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  #leaderboard .ranking-rewards {
    border-collapse: collapse;
    width: 100%;
  }
  #leaderboard .ranking-rewards td {
    padding: 5px 10px;
  }
  #leaderboard .ranking-rewards tr:nth-child(2) {
    --bgcolor: #666666;
    background-color: var(--bgcolor);
    color: #ffffff;
  }
</style>


// WEBPACK FOOTER //
// src/components/main-page-leaderboard-list.vue